import { Component, HostListener, Input } from '@angular/core';
import { News, Organisation } from '../../../models/types';
import { LoginService } from '../../services/login.service';
import { OrganisationServiceService } from '../../services/organisation-service.service';
import { EventService } from '../../services/event.service';
import { ActivatedRoute } from '@angular/router';
import { ProfilePageService } from '../../services/profile-page.service';
import { Event } from '../../../models/types';
import { imageLocation } from '../../../environments/environment.development';
import { GalleryImage, GalleryItemEvent } from '@daelmaak/ngx-gallery';
import Swal from 'sweetalert2';
import { HttpResponse } from '@angular/common/http';
import { GalleryModule } from '@daelmaak/ngx-gallery';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTrash, faPlus, faCalendar, faHouse, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { NewsListComponent } from '../news-list/news-list.component';
import { EventListComponent } from '../event-list/event-list.component';
import { FullCalendarComponent } from '../full-calendar/full-calendar.component';
import { FormsModule } from '@angular/forms';
import { ReportListComponent } from "../report-list/report-list.component";
import { fullHistory } from '../../../models/enums';

@Component({
  selector: 'app-regional-authority',
  standalone: true,
  imports: [
    GalleryModule,
    CommonModule,
    FontAwesomeModule,
    NewsListComponent,
    EventListComponent,
    FullCalendarComponent,
    FormsModule,
    ReportListComponent,
    NgOptimizedImage
],
  templateUrl: './regional-authority.component.html',
  styleUrl: './regional-authority.component.scss'
})
export class RegionalAuthorityComponent {
  @Input() isSuperAdmin: boolean = false;
  @Input() organisation: Organisation | null = null;

  isOrgAdmin: boolean = false;
  organisationId: string = '';
  allEvents: Event[] = [];
  news: News[] = [];
  isLoading: boolean = true;
  error: string | null = null;
  govImages: GalleryImage[] = [];
  selectedImageIndex = -1;
  imageSelected = false;
  menuOpen = false;
  oldHallEvents: Event[] = [];
  showAddLeaderForm = false;
  currentPage: number = 1;
  pageSize: number = 4;
  totalItems: number = 0;

  faPlus = faPlus;
  faTrash = faTrash;
  faCalendar = faCalendar;
  faHouse = faHouse;
  faEnvelope = faEnvelope;
  faPhone = faPhone;
  fullHistory: string = fullHistory;

  shortHistory: string = fullHistory.substring(0, 500);

  showFullHistory: boolean = false;

  showReservationForm = false;
  reservation = {
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    duration: '',
    description: '',
    isProfitable: ''
  };

  newLeader = {
    leaderID: 0,
    role: '',
    name: '',
    email: '',
    phone: '',
    imageRef: '',
    organisationID: 0
  };

  oldHallImages: { src: string, alt: string }[] = [
    { src: '../../../assets/images/organisations/gov/hall1.jpg', alt: 'Stara šola 1' },
    { src: '../../../assets/images/organisations/gov/hall2.jpg', alt: 'Stara šola 1' },
    { src: '../../../assets/images/organisations/gov/hall3.jpg', alt: 'Stara šola 1' },
  ];

  dvoranaImages: { src: string, alt: string }[] = [
    { src: '../../../assets/images/organisations/gov/sola2.jpg', alt: 'Dvorana 1' },
    { src: '../../../assets/images/organisations/gov/sola3.jpg', alt: 'Dvorana 2' },
    { src: '../../../assets/images/organisations/gov/sola4.jpg', alt: 'Dvorana 3' },
  ];

  constructor(
    private loginService: LoginService,
    private organisationService: OrganisationServiceService,
    private route: ActivatedRoute,
    private eventService: EventService,
    private profilePageService: ProfilePageService,
  ) { }

  ngOnInit(): void {
    this.isOrgAdmin = this.loginService.IsOrgAdminLoggedIn("government")
    //this.extractOrganisationId();
    this.extractOrganisationIdFromName(); 
    this.handleScroll();
  }

  extractOrganisationIdFromName() {
    this.organisationService.getOrganisationIdByName("Krajevna Skupnost Hotedršica").subscribe({
      next: (response) => {
        this.organisationId = response.body?.organisationID.toString() || '';
        this.loadEvents();
        this.getNews();
        this.fetchOrgImages();
      },
      error: (err) => {
        console.error('Error extracting organisation ID:', err);
      }
    });
  }

  extractOrganisationId() {
    this.route.paramMap.subscribe(params => {
      this.organisationId = params.get('orgID')!;
    });
  }

  @HostListener('window:scroll', [])
  handleScroll() {
    const images = document.querySelectorAll('.animated-image') as NodeListOf<HTMLElement>;
    const titles = document.querySelectorAll('.animated-title') as NodeListOf<HTMLElement>;
    const texts = document.querySelectorAll('.animated-text') as NodeListOf<HTMLElement>;

    this.animateOnScroll(images, 'left-image', 'slide-in-left');
    this.animateOnScroll(images, 'right-image', 'slide-in-right');
    this.animateOnScroll(titles, '', 'slide-in-left'); // No specific class, so we just add the animation
    this.animateOnScroll(texts, '', 'slide-in-right'); // No specific class, just add the animation
  }
  
  private animateOnScroll(elements: NodeListOf<HTMLElement>, className: string, animationClass: string) {
    elements.forEach(element => {
      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        if (className === '' || element.classList.contains(className)) {
          element.classList.add(animationClass);
        }
      }
    });
  }

  loadEvents() {
    this.eventService.getAllEvents().subscribe((response) => {
      this.allEvents = response.events!.filter((event: Event) => event.organisationID === Number(this.organisationId));
      this.oldHallEvents = response.events!.filter((event: Event) => event.organisationName === 'old_hall');
      this.allEvents = response.events!.filter((event: Event) => event.organisationID === Number(this.organisationId) && event.organisationName !== 'old_hall');
    });
  }

  getNews() {
    this.isLoading = true;
  
    this.organisationService.getPaginatedNews(this.currentPage, this.pageSize, this.organisationId).subscribe({
      next: (response) => {
        if (response && Array.isArray(response.news)) {
          const newNews = this.assignNewsImages(response.news);
          this.news = [...this.news, ...newNews]; // Append, don't replace
          this.totalItems = response.total;
        } else {
          this.news = [];
        }
  
        this.isLoading = false;
      },
      error: (err) => {
        this.error = 'Failed to load news.';
        this.isLoading = false;
      }
    });
  }
  

loadMoreNews() {
  this.currentPage++;
  this.getNews(); // will use the updated page
}

  private assignNewsImages(news: News[]): News[] {
    return news.map(newsItem => {
      let defaultImageUrl = '../../../assets/images/generic/news.png';
      newsItem.imageRef = newsItem.imageRef ?
      `${imageLocation}/static/content/news/${newsItem.newsID}/${newsItem.imageRef}` :
      defaultImageUrl;
      return newsItem;
    })
  }

deleteSelectedImage() {
    if (this.selectedImageIndex !== null) {
      Swal.fire({
        title: 'Ali želite nadaljevati?',
        text: 'Ali želite izbrisati sliko?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da, izbriši!',
        cancelButtonText: 'Ne, prekliči!'
      }).then((result) => {
        if (result.isConfirmed) {
          const imageToDelete = this.govImages[this.selectedImageIndex];
          const pictureSrc = imageToDelete.src;
  
          this.organisationService.deleteOrgImage(Number(this.organisationId), pictureSrc).subscribe({
            next: (response: HttpResponse<any>) => {
              console.log('Image deleted successfully:', response);
              this.govImages.splice(this.selectedImageIndex, 1); // Remove image from the gallery
              this.selectedImageIndex = -1;
              this.imageSelected = false;
            },
            error: (err) => {
              console.error('Failed to delete image:', err);
            }
          });
        } else {
          console.log('Image deletion cancelled');
        }
      });
    } else {
      console.log('No image selected for deletion');
    }
  }

  fetchOrgImages() {
    this.organisationService.getOrganisationImages(this.organisation!.organisationID).subscribe({
      next: (response) => {
        this.govImages = response.body?.images.map((image: any) => {
          return new GalleryImage(
            `${imageLocation}/static/content/organizations/${this.organisationId}/${image}`,
            `${imageLocation}/static/content/organizations/${this.organisationId}/${image}`,
          );
        }) || []; // Fallback to empty array if response.body is null
      },
      error: (err) => {
        console.error('Failed to fetch organisation images:', err);
      }
    });
  } 

  onThumbClick(event: GalleryItemEvent) {
    this.selectedImageIndex = event.index;
    this.imageSelected = true;
    console.log(`Selected image index: ${this.selectedImageIndex}`);
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  scrollTo(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 300; // Adjust this value to stop scrolling earlier
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    this.menuOpen = false;
  }

  openAddSportsImagesModal() {
    this.profilePageService.openOrgImageAddModal(this.organisation!);  
  }

  openHallReservationForm() {
    this.showReservationForm = true;
  }
  
  submitReservation() {
    this.isLoading = true;
    this.organisationService.sendHallReservation(this.reservation).subscribe({
      next: () => {
        Swal.fire({
          title: 'Uspeh!',
          text: 'Rezervacija uspešno poslana!',
          icon: 'success',
          confirmButtonText: 'V redu'
        });
        this.showReservationForm = false;
        this.isLoading = false;
        this.reservation = { name: '', email: '', phone: '', date: '', time: '', duration: '', description: '', isProfitable: '' };
      },
      error: (err) => {
        console.error('Napaka pri pošiljanju rezervacije:', err);
        Swal.fire({
          title: 'Napaka!',
          text: 'Napaka pri pošiljanju. Poskusite znova.',
          icon: 'error',
          confirmButtonText: 'V redu'
        });
        this.isLoading = false;
      }
    });
  }
  deleteLeader(id: number) {
    this.organisationService.deleteLeader(id).subscribe({
      next: (response) => {
        console.log('Leader deleted:', response);
      },
      error: (err) => {
        console.error('Error deleting leader:', err);
      }
    });
  }
  
  onSubmitAddLeader() {
    this.newLeader.organisationID = parseInt(this.organisationId);
    if (this.newLeader.name && this.newLeader.role && this.newLeader.email && this.newLeader.phone && this.newLeader.organisationID) {
      this.organisationService.addLeader(this.newLeader).subscribe({
        next: (response) => {
          this.newLeader = { leaderID: 0, role: '', name: '', email: '', phone: '', imageRef: '', organisationID: 0 };
          Swal.fire({
            title: 'Uspešno dodano!',
            text: 'Vodja uspešno dodan! Prosim osvežite stran, da vidite spremembe.',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500
          });
        },
        error: (error) => {
          console.error('Error adding leader:', error);
        }
      });
    } else {
      console.log('Please fill in all required fields.');
    }
  }

  toggleAddLeaderForm() {
    this.showAddLeaderForm = !this.showAddLeaderForm;
  }

  toggleHistory() {
    this.showFullHistory = !this.showFullHistory;
  }

  handleNewsChanged() {
    this.news = [];
    this.currentPage = 1;
    this.getNews();
  }

  handleEventsChanged() {
    this.allEvents = [];
    this.currentPage = 1;
    this.loadEvents();
  }
}
